import { _ as h, a as y, h as R, b as _, c as b, d as w, u as S, g as I, e as x } from "./handler-d792c287.mjs";
import { s as ae } from "./handler-d792c287.mjs";
import { S3Client as K, GetObjectCommand as T } from "@aws-sdk/client-s3";
import { Upload as z } from "@aws-sdk/lib-storage";
import P, { forwardRef as B, useRef as H, useState as j } from "react";
import { FetchHttpHandler as A } from "@smithy/fetch-http-handler";
import { getSignedUrl as D } from "@aws-sdk/s3-request-presigner";
import "@aws-sdk/client-sts";
import "uuid";
var C = function(n) {
  n === void 0 && (n = {});
  var r = function(o, s) {
    return h(this, void 0, void 0, function() {
      var i, a;
      return y(this, function(c) {
        switch (c.label) {
          case 0:
            return c.trys.push([0, 2, , 3]), [4, R({
              request: o,
              options: n
            })];
          case 1:
            return i = c.sent(), s.status(200).json(i), [3, 3];
          case 2:
            return a = c.sent(), console.error(a), s.status(500).json({ error: "Internal Server Error" }), [3, 3];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, e = function(o) {
    return C(o);
  };
  return Object.assign(r, { configure: e });
}, Z = C(), E = B(function(n, r) {
  var e = n.onChange, o = e === void 0 ? function() {
  } : e, s = _(n, ["onChange"]), i = function(a) {
    var c, t, d = (t = (c = a.target) === null || c === void 0 ? void 0 : c.files) === null || t === void 0 ? void 0 : t[0];
    o(d, a);
  };
  return P.createElement("input", b({ onChange: i }, s, { ref: r, type: "file" }));
}), L = function() {
  var n = H(), r = j([]), e = r[0], o = r[1], s = function() {
    var t;
    n.current && (n.current.value = "", (t = n.current) === null || t === void 0 || t.click());
  }, i = function() {
    o([]);
  }, a = function(t, d) {
    o(function(f) {
      return f.map(function(u) {
        return u.file === t ? {
          file: t,
          uploaded: d,
          id: u.id,
          size: t.size,
          progress: t.size ? d / t.size * 100 : 0
        } : u;
      });
    });
  }, c = function(t) {
    o(function(d) {
      return w(w([], d, !0), [
        {
          file: t,
          progress: 0,
          uploaded: 0,
          size: t.size,
          id: S()
        }
      ], !1);
    });
  };
  return {
    FileInput: function(t) {
      return P.createElement(E, b({}, t, { ref: n, style: { display: "none" } }));
    },
    openFileDialog: s,
    files: e,
    addFile: c,
    updateFileProgress: a,
    resetFiles: i
  };
}, F = function(n, r, e) {
  var o = L(), s = o.addFile, i = o.updateFileProgress, a = o.FileInput, c = o.openFileDialog, t = o.files, d = o.resetFiles, f = function(u, v) {
    return v === void 0 && (v = {}), h(void 0, void 0, void 0, function() {
      var p, l, g;
      return y(this, function(m) {
        switch (m.label) {
          case 0:
            return e != null && e.endpoint && (process.env.NODE_ENV === "development" && console.warn("[Next S3 Upload] The `endpoint` option has been replaced by `endpoint.request.url`. For more information see: https://next-s3-upload.codingvalue.com/changes/endpoint"), v.endpoint ? v.endpoint.request.url = e.endpoint : v.endpoint = {
              request: {
                url: e.endpoint
              }
            }), [4, N(n, u, (g = v.endpoint) === null || g === void 0 ? void 0 : g.request)];
          case 1:
            if (p = m.sent(), p.error)
              throw console.error(p.error), p.error;
            return s(u), [4, r(u, p, {
              onProgress: function(k) {
                return i(u, k);
              }
            })];
          case 2:
            return l = m.sent(), [2, l];
        }
      });
    });
  };
  return {
    FileInput: a,
    openFileDialog: c,
    uploadToS3: f,
    files: t,
    resetFiles: d
  };
}, N = function(n, r, e) {
  return h(void 0, void 0, void 0, function() {
    var o, s, i, a, c, t, d, f, u;
    return y(this, function(v) {
      switch (v.label) {
        case 0:
          return o = (d = e == null ? void 0 : e.body) !== null && d !== void 0 ? d : {}, s = (f = e == null ? void 0 : e.headers) !== null && f !== void 0 ? f : {}, i = (u = e == null ? void 0 : e.url) !== null && u !== void 0 ? u : "/api/s3-upload", a = b({ filename: r.name, filetype: r.type, _nextS3: {
            strategy: n
          } }, o), c = b(b({}, s), { "Content-Type": "application/json" }), [4, fetch(i, {
            method: "POST",
            headers: c,
            body: JSON.stringify(a)
          })];
        case 1:
          return t = v.sent(), [4, t.json()];
        case 2:
          return [2, v.sent()];
      }
    });
  });
}, q = function(n, r, e) {
  var o = e.onProgress;
  return h(void 0, void 0, void 0, function() {
    var s, i, a, c, t, d, f, u, v, p, l;
    return y(this, function(g) {
      switch (g.label) {
        case 0:
          return s = r.key, i = r.bucket, a = r.token, c = r.region, t = new K({
            requestHandler: new A({ keepAlive: !1 }),
            credentials: {
              accessKeyId: a.Credentials.AccessKeyId,
              secretAccessKey: a.Credentials.SecretAccessKey,
              sessionToken: a.Credentials.SessionToken
            },
            region: c
          }), d = {
            Bucket: i,
            Key: s,
            Body: n,
            CacheControl: "max-age=630720000, public",
            ContentType: n.type
          }, f = new z({
            client: t,
            params: d
          }), f.on("httpUploadProgress", function(m) {
            var k, U = (k = m.loaded) !== null && k !== void 0 ? k : 0;
            o(U);
          }), [4, f.done()];
        case 1:
          return u = g.sent(), v = u.Bucket && u.Key ? "https://".concat(u.Bucket, ".s3.").concat(c, ".amazonaws.com/").concat(u.Key) : "", [2, {
            url: v,
            bucket: (p = u.Bucket) !== null && p !== void 0 ? p : "",
            key: (l = u.Key) !== null && l !== void 0 ? l : ""
          }];
      }
    });
  });
}, O = function(n) {
  var r = F("aws-sdk", q, n);
  return r;
}, G = function(n, r, e) {
  var o = e.onProgress;
  return h(void 0, void 0, void 0, function() {
    var s, i, a, c, t, d, f;
    return y(this, function(u) {
      switch (u.label) {
        case 0:
          return s = r.url, i = r.key, a = r.bucket, c = r.region, t = r.endpoint, [4, n.arrayBuffer()];
        case 1:
          return d = u.sent(), [4, new Promise(function(v, p) {
            var l = new XMLHttpRequest();
            l.upload.onprogress = function(g) {
              o(g.loaded);
            }, l.open("PUT", s, !0), l.setRequestHeader("Content-Type", n.type), l.setRequestHeader("Cache-Control", "max-age=630720000"), l.onreadystatechange = function() {
              l.readyState === 4 && (l.status >= 200 && l.status < 300 ? v() : p());
            }, l.send(d);
          })];
        case 2:
          return u.sent(), f = t ? "".concat(t, "/").concat(a, "/").concat(i) : "https://".concat(a, ".s3.").concat(c, ".amazonaws.com/").concat(i), [2, {
            url: f,
            bucket: a,
            key: i
          }];
      }
    });
  });
}, ee = function() {
  var n = F("presigned", G);
  return n;
}, ne = function(n) {
  return new Promise(function(r) {
    var e;
    if (((e = n.type.split("/")) === null || e === void 0 ? void 0 : e[0]) === "image") {
      var o = new Image(), s = URL.createObjectURL(n);
      o.onload = function(i) {
        var a = i.target;
        r({ height: a.height, width: a.width }), URL.revokeObjectURL(s);
      }, o.src = s;
    } else
      r({ height: void 0, width: void 0 });
  });
}, re = function(n, r) {
  return h(void 0, void 0, void 0, function() {
    var e, o, s, i;
    return y(this, function(a) {
      switch (a.label) {
        case 0:
          return e = I(r), o = x(r), s = new T({
            Bucket: e.bucket,
            Key: n
          }), [4, D(o, s, { expiresIn: 3600 })];
        case 1:
          return i = a.sent(), [2, i];
      }
    });
  });
};
export {
  Z as APIRoute,
  re as generateTemporaryUrl,
  ne as getImageData,
  ae as sanitizeKey,
  ee as usePresignedUpload,
  O as useS3Upload,
  S as uuid
};
